import $ from "jquery";
import React, { Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import AllCompanies from './AllCompanies';
import OwnCompany from './OwnCompany';
import SortCompany from "./SortCompany";
import AllRequestedCompany from "./AllRequestedCompany";
import AllRejectedCompany from "./AllRejectedCompany";

const Company = (props) => {
    const [currentTab, setCurrentTab] = useState("all-company");
    const [userProfile, setUserProfile] = useState({});


    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }

    useEffect(() => {
        // User Profile
        PostLoginGetApi("user/profile", "",).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setUserProfile(responseData["data"]);
                }
            }

        }).catch((err) => {
            console.log(err);
        })
    }, [])

    const { state } = useLocation();

    useEffect(() => {
        if (state?.tab !== null && state?.tab !== undefined && state?.tab !== "") {
            if (state?.tab === "own-company") {
                $(".tablinks").eq(1).trigger("click");
            }
            if (state?.tab === "all-company") {
                $(".tablinks").eq(0).trigger("click");
            }

        }
    }, [state, userProfile]);


    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20 ">


            {/* TAB SWITCHER */}
            {(userProfile?.user_type === "Super Admin" || userProfile?.user_type === "User") ?
                <>
                    <div className="tab w-full">
                        <button className="tablinks current" onClick={(event) => handleTab("all-company", event)}>All Company</button>
                        <button className="tablinks" onClick={(event) => handleTab("own-company", event)}>Own Company</button>
                        {userProfile?.user_type === "Super Admin" && 
                            <>
                                <button className="tablinks" onClick={(event) => handleTab("sort-company", event)}>Position Setup</button>
                                <button className="tablinks" onClick={(event) => handleTab("registration-request", event)}>Registration Request</button>
                                <button className="tablinks" onClick={(event) => handleTab("rejected-request", event)}>Rejected Request</button>
                            </>
                        }
                    </div>

                    <div className='tabcontentbody py-3 px-0'>
                        <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px", paddingRight: "0px" }}>
                            <Suspense fallback="Loading...">

                                {(() => {
                                    switch (currentTab) {
                                        case "all-company":
                                            return <AllCompanies userProfile={userProfile} />;
                                        case "own-company":
                                            return <OwnCompany currentTab={currentTab} userProfile={userProfile} />;
                                        case "sort-company":
                                            return <SortCompany currentTab={currentTab} userProfile={userProfile} />;
                                        case "registration-request":
                                            return <AllRequestedCompany currentTab={currentTab} userProfile={userProfile} />;
                                        case "rejected-request":
                                            return <AllRejectedCompany currentTab={currentTab} userProfile={userProfile} />;
                                        default:
                                            return <>No page found</>;
                                    }
                                })()}

                            </Suspense>
                        </div>
                    </div>
                </>
                :
                <OwnCompany userProfile={userProfile} />
            }



            <style>{`
                .custom-scroll-auto { 
                    overflow-x: hidden;
                }

                .tab button:hover::after, .tab button.current::after { 
                    width: 120% !important;
                    margin-left: -10% !important;
                }
                `}</style>


        </div>
    );
};

export default Company;